import { useMutation, UseMutationOptions, useQuery, UseQueryResult } from 'react-query';
import { IContactForm, IUser } from '../types';
import { getNotifications, getProfile, getUserByCode, sendContactMessage, updateProfile } from './api.ts';

export enum UserHook {
  Profile = 'profile',
  Notifications = 'notifications',
}

export function useGetUserByCodeMutation(options: UseMutationOptions<IUser, unknown, string, unknown>) {
  return useMutation((code: string) => getUserByCode(code), options);
}

export function useProfile(): UseQueryResult<IUser | null> {
  return useQuery(UserHook.Profile, () => getProfile());
}

export function useNotifications() {
  return useQuery(UserHook.Notifications, getNotifications);
}

export function useUpdateProfileMutation(
  options: UseMutationOptions<IUser | null, unknown, Record<string, string | boolean>, unknown>
) {
  return useMutation((data: Record<string, string | boolean>) => updateProfile(data), options);
}

export function useSendContactMutation(options: UseMutationOptions<unknown, unknown, IContactForm, unknown>) {
  return useMutation((data: IContactForm) => sendContactMessage(data), options);
}
